import {
  EverydayLife,
  Sustainability,
  Safety,
  Communication,
  Maintenance,
  MovingInOut,
} from 'components/brikks/home/MyHome/components/LivingInfoModal/components/LKFLivingInfo/components';
import {
  ApartmentTable,
} from 'components/brikks/home/MyHome/components/LivingInfoModal/components/LivingInfo/components';

export const RibLivingInfoOptions = [
  {
    menu: 'apartmentInfo',
    submenus: [],
    content: ApartmentTable,
  },
  {
    menu: 'everydayLife',
    submenus: [],
    content: EverydayLife,
  },
  {
    menu: 'sustainability',
    submenus: [],
    content: Sustainability,
  },
  {
    menu: 'safety',
    submenus: [],
    content: Safety,
  },
  {
    menu: 'communication',
    submenus: [],
    content: Communication,
  },
  {
    menu: 'maintenance',
    submenus: [],
    content: Maintenance,
  },
  {
    menu: 'movingInOut',
    submenus: [],
    content: MovingInOut,
  },
];
